import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SelectBankImage from "../../assets/images/selectBankAccountScore.png";
import IdCheckImage from "../../assets/images/bankIDcheck.png";
import BankAuthImage from "../../assets/images/bankAuth.png";
import BankDoneImage from "../../assets/images/AccountScoreBankDone.png"

function AccountScoreBankReport() {
   const [step, setStep] = useState("selectBank");
   const navigate = useNavigate();

   const handleRedirect = () => {
      navigate("/thankYou");
   };

   return (
      <div>
         {step === "selectBank" && (
            <div style={{ height: '100vh', cursor: 'pointer' }} onClick={() => setStep("idCheck")}>
               <img
                  src={SelectBankImage}
                  alt="Select Bank"
                  style={{ width: "100%" }}
               />
            </div>
         )}

         {step === "idCheck" && (
            <div style={{ height: '100vh', cursor: 'pointer' }} onClick={() => setStep("bankAuth")}>
               <img
                  src={IdCheckImage}
                  alt="ID Check"
                  style={{ width: "100%" }}
               />
            </div>
         )}

         {step === "bankAuth" && (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", cursor: 'pointer' }} onClick={() => setStep("bankDone")}>
               <img
                  src={BankAuthImage}
                  alt="Bank Auth"
               />
            </div>
         )}

         {step === "bankDone" && (
            <div style={{ height: '100vh', cursor: 'pointer' }} onClick={handleRedirect}>
               <img
                  src={BankDoneImage}
                  alt="Bank Done"
                  style={{ width: "100%" }}
               />
            </div>
         )}
      </div>
   );
}

export default AccountScoreBankReport;